//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

import { get } from 'lodash'

export const getReports = state => get(state, 'salesByCategoryCSV') || {}
export const getStartDate = state => get(state, 'salesByCategoryCSV.startDate')
export const getEndDate = state => get(state, 'salesByCategoryCSV.endDate')
